<div class="bulk-upload-dialog">

    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>

    <h2>Bulk Upload {{ data.type | titlecase }}</h2>
    <p class="subtitle">
        Download the template, fill in the data, and upload the CSV file
    </p>

    <!-- Template Download -->
    <div class="template-box">
        <div>
            <h4>Download Template</h4>
            <p>Get the CSV template with required columns</p>
        </div>
        <button mat-stroked-button color="primary" (click)="downloadTemplate()">
            <mat-icon>download</mat-icon> Download
        </button>
    </div>

    <!-- Upload Area -->
    <div class="upload-area">
        <mat-icon class="upload-icon">upload</mat-icon>
        <h4>Upload CSV File</h4>
        <p>Click to browse or drag and drop</p>

        <label class="file-input">
            <input type="file" accept=".csv" (change)="onFileSelected($event)" />
            <span>{{ selectedFileName || 'Choose File' }}</span>
        </label>
    </div>

    <!-- Actions -->
    <div class="actions">
        <button mat-stroked-button (click)="close()">Cancel</button>

        <button mat-flat-button color="primary" class="import-btn" [disabled]="!selectedFileName || isLoading"
            (click)="importFile()">

            <span *ngIf="isLoading">Processing...</span>
            <span *ngIf="!isLoading">
                Import {{ data.type | titlecase }}
            </span>

        </button>
    </div>

</div>